module.exports = __webpack_public_path__ + "img/detection_center.acc292fa.png";